// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Services_carousel__s_CrR"};